import { useEffect } from 'react'

interface VideoLightboxProps {
  title: string
  src: string
  onClose: () => void
}

// Fullscreen video modal (Figma 43:101 floating frames): dark overlay, close
// on the X and on any click outside the player, body scroll locked while open.
const VideoLightbox = ({ title, src, onClose }: VideoLightboxProps) => {
  useEffect(() => {
    const previousOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = previousOverflow
    }
  }, [])

  return (
    <div className="video-lightbox" role="dialog" aria-modal="true" onClick={onClose}>
      <div className="video-lightbox__panel" onClick={(event) => event.stopPropagation()}>
        <div className="video-lightbox__head">
          <p className="video-lightbox__title">{title}</p>
          <button type="button" className="video-lightbox__close" aria-label="Cerrar" onClick={onClose}>
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2 2l14 14M16 2L2 16" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </button>
        </div>
        {/* encodeURI: CDN video names contain spaces */}
        <video className="video-lightbox__video" src={encodeURI(src)} controls autoPlay playsInline />
      </div>
    </div>
  )
}

export default VideoLightbox
